import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper';
import React from 'react';
import { useGetSliderImages } from '@/hooks/dataProvider';
import AuthImageById from './AuthImageById';

const HomeBannerSlider = () => {
  const { data: sliderImages } = useGetSliderImages();
  if (!sliderImages?.length) {
    return null;
  }
  return (
    <section className="layout-pt-sm layout-pb-sm">
      <div className="container">
        <div className="relative overflow-hidden pt-40 sm:pt-20 js-section-slider item_gap-x30">
          <Swiper
            spaceBetween={30}
            modules={[Navigation, Pagination, Autoplay]}
            autoplay
            navigation={{
              nextEl: '.js-hotels-next',
              prevEl: '.js-hotels-prev',
            }}
            pagination={{
              el: '.hotel-banner-slider',
              clickable: true,
            }}
            breakpoints={{
              540: {
                slidesPerView: 1,
                spaceBetween: 20,
              },
              768: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              1024: {
                slidesPerView: 3,
              },
              1200: {
                slidesPerView: 3,
              },
            }}
          >
            {sliderImages?.map((item, index) => (
              <SwiperSlide key={index}>
                <a href={item.hyperlink} target="_blank" rel="noreferrer" className="rounded-22">
                  <AuthImageById imageId={item.fileId || ''} className="rounded-22 col-12 js-lazy" alt={item.hyperlink} />
                </a>
              </SwiperSlide>
            ))}
          </Swiper>

          <div className="d-flex x-gap-15 items-center justify-center pt-40 sm:pt-20">
            <div className="col-auto">
              <button className="d-flex items-center text-24 arrow-left-hover js-hotels-prev">
                <i className="icon icon-arrow-left" />
              </button>
            </div>
            {/* End .prev */}

            <div className="col-auto">
              <div className="pagination -dots text-border hotel-banner-slider" />
            </div>
            {/* End .pagination */}

            <div className="col-auto">
              <button className="d-flex items-center text-24 arrow-right-hover js-hotels-next">
                <i className="icon icon-arrow-right" />
              </button>
            </div>
            {/* End .next */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeBannerSlider;
